export const exterior_view07ImageOptions = {
  angle: 'exterior_view07',
  staticOptions: {
    HullColour: 1,
    BowSprit: 1,
    HullTreatment: 1,
    TeakOnSideDecks: 1,
    BiminiForHelmsman: 1,
    BiminiForForwardCockpit: 1,
    CockpitTent: 1,
    Wheel: 1,
    MastAndBoom: 1,
    BoomCover: 1,
    LiftingArm: 1,
    Gangway: 1,
    SolarPanels: 1,
    WheelingSeats: 1,
    Boom: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: null
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'Wheel',
      dependency: 'AftBench'
    },
    {
      option: 'MastAndBoom',
      dependency: null
    },
    {
      option: 'BoomCover',
      dependency: 'MastAndBoom'
    },
    {
      option: 'SolarPanels',
      dependency: null
    },
    {
      option: 'WheelingSeats',
      dependency: 'AftBench'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X56/views/exterior_view07.js